import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Link, SidebarModal } from '@domain-group/suit-theme'

import useUser, { useRelations } from '@hooks/useUser'

interface UserProps {
  callbacks: {
    deleteUser: VoidFunction,
  },
  userId: number,
}

const User = (props: UserProps) => {
  const {
    callbacks: {
      deleteUser,
    },
    userId,
  } = props

  const userPayload = useUser({ id: userId }, {
    performHttpRequests: !!userId,
    requestOptions: {
      include_image_sizes: true,
      // @ts-expect-error TS2353
      include_user_association: true,
      include_user_image: true,
      include_user_type: true,
    },
  })
  const { user } = userPayload

  const { agency, image, role } = useRelations(user)

  return (
    <SidebarModal.User
      disableHover
      // @ts-expect-error TS2339
      imageUrl={image.square_url}
      // @ts-expect-error TS2339
      subtitle={role.title ? `${role.title} | ${agency.title}` : 'Loading...'}
      title={user.title}
    >
      <Link greyLink onClick={deleteUser}>
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </SidebarModal.User>
  )
}

export default User
